import { observer } from 'mobx-react';
import * as React from 'react';
import { AgendaItem } from '../store/schema/AgendaItem';
import { getColorScheme } from 'owa-calendar-color-resolver';
import { getScenarioActions } from '../actions/getScenarioActions';
import { getCalendarEventIcons } from 'owa-calendar-event-icons';
import { getScenarioSelectors } from '../selectors/agendaStoreSelectors';
import {
    AgendaEventViewAllDay,
    AgendaEventViewUpNext,
    AgendaEventViewNormal,
} from 'owa-agenda-event-views-wrappers';

export interface AgendaEventViewControllerProps {
    agendaItem: AgendaItem;
    scenarioId: string;
    className: string;
}

@observer
export class AgendaEventViewController extends React.Component<AgendaEventViewControllerProps> {
    render() {
        const { agendaItem, className, scenarioId } = this.props;
        const { isUpNextCalendarEvent, isSelectedCalendarEvent } = getScenarioSelectors(scenarioId);

        const viewProps = {
            id: agendaItem.id,
            freeBusyType: agendaItem.freeBusyType,
            onClick: this.onClick,
            onDoubleClick: this.onDoubleClick,
            onRightClick: this.onRightClick,
            colorScheme: getColorScheme(agendaItem.parentFolderId.Id, agendaItem.categories),
            icons: getCalendarEventIcons(
                agendaItem.hasAttachments,
                agendaItem.isRecurring,
                agendaItem.isPrivate,
                agendaItem.isRecurringException
            ),
            isSelected: isSelectedCalendarEvent(agendaItem.id.Id),
            className: className,
        };
        let AgendaEventView;

        if (agendaItem.isAllDay) {
            AgendaEventView = AgendaEventViewAllDay;
        } else if (isUpNextCalendarEvent(agendaItem.id.Id)) {
            AgendaEventView = AgendaEventViewUpNext;
        } else {
            AgendaEventView = AgendaEventViewNormal;
        }

        return <AgendaEventView {...viewProps} {...agendaItem} />;
    }

    private onClick = evt => {
        const { agendaItem, scenarioId } = this.props;
        const { clickAgendaEvent, updateSelectedCalendarEvent } = getScenarioActions(scenarioId);
        updateSelectedCalendarEvent(agendaItem.id.Id);
        clickAgendaEvent(agendaItem.id, evt.currentTarget);
    };

    private onDoubleClick = evt => {
        const { agendaItem, scenarioId } = this.props;
        const { doubleClickAgendaEvent, updateSelectedCalendarEvent } = getScenarioActions(
            scenarioId
        );
        updateSelectedCalendarEvent(agendaItem.id.Id);
        doubleClickAgendaEvent(agendaItem.id, evt.currentTarget);
    };

    private onRightClick = evt => {
        const { agendaItem, scenarioId } = this.props;
        const { updateSelectedCalendarEvent, rightClickAgendaEvent } = getScenarioActions(
            scenarioId
        );
        updateSelectedCalendarEvent(agendaItem.id.Id);
        evt.persist();
        evt.stopPropagation();
        evt.preventDefault();
        rightClickAgendaEvent(agendaItem.id, agendaItem.parentFolderId.Id, evt);
    };
}
